import React from "react";
import PropTypes from "prop-types";
import StyledShopBreadCrumbEverscore from "./ShopBreadCrumbEverscore.styled";
import SVGIcon from "../utility/SVGIcon";

const ShopBreadCrumbEverscore = React.memo((props) => {
    const {name, id, clearAll, count, selectType, checkFilter, checkFilterPrice, disabled, uri_param} = props;
    return (
      <StyledShopBreadCrumbEverscore
          disabled={count === 0 || disabled}
          className="t-font-artifex"
          onClick={
            () => {
                if(clearAll)
                {
                    return clearAll()
                } else {
                    return selectType !== "priceRange" ? checkFilter(uri_param, selectType, name) : checkFilterPrice(id, 0 , 0)
                }
            }}
      >
          {!clearAll && <SVGIcon name="close" width="8"/>}
          {clearAll && <span>{name} {`(${count})`}</span>}
          {!clearAll && <span>{name}</span>}
      </StyledShopBreadCrumbEverscore>
    );
});

ShopBreadCrumbEverscore.propTypes = {
    name: PropTypes.string,
    clearAll: PropTypes.func,
    disabled: PropTypes.bool,
    count: PropTypes.number,
    key: PropTypes.string,
    id: PropTypes.string,
    uri_param: PropTypes.string,
    selectType: PropTypes.string,
    checkFilter: PropTypes.func,
    checkFilterPrice: PropTypes.func,
};

export default ShopBreadCrumbEverscore;
